import React from 'react'
import styled from 'styled-components'
import SubItem from './header-menu-main-desktop-sub-item.js'
import theme from './theme.js'

const DesktopSubMenu = ({
  items
}) => {
  if (!items) return

  const subItems = items.map(item => {
    const props = {
      item,
      key: item.title
    }

    return <SubItem {...props}/>
  })

  return (
    <SubMenu className='sub-menu'>
      {subItems}
    </SubMenu>
  )
}

const SubMenu = styled.div`
  position: absolute;
  display: none;
  top: 100%;
  z-index: 1;
  white-space: nowrap;
  background: ${theme.color.grey.medium};
  padding: 1rem 2rem;

  &:hover {
    display: block;
  }

  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    height: 100%;
    background: ${theme.color.grey.lightest};
  }
`

export default DesktopSubMenu